export const LOGO_URL = "https://i.pinimg.com/originals/68/7d/ed/687dedbb44330094705fe031b63b8efa.png";

export const CDN_URL = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

export const MENU_API = "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=21.1544444&lng=78.9943191&restaurantId=";